var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasyOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2225 5.68457L11.66 1.54668C11.4579 1.43503 11.2309 1.37646 11 1.37646C10.7691 1.37646 10.5421 1.43503 10.34 1.54668L2.7775 5.68629C2.56153 5.80445 2.38125 5.97844 2.25547 6.19007C2.1297 6.40171 2.06306 6.64323 2.0625 6.88941V15.1085C2.06306 15.3547 2.1297 15.5962 2.25547 15.8078C2.38125 16.0194 2.56153 16.1934 2.7775 16.3116L10.34 20.4512C10.5421 20.5629 10.7691 20.6214 11 20.6214C11.2309 20.6214 11.4579 20.5629 11.66 20.4512L19.2225 16.3116C19.4385 16.1934 19.6188 16.0194 19.7445 15.8078C19.8703 15.5962 19.9369 15.3547 19.9375 15.1085V6.89027C19.9374 6.64365 19.871 6.40159 19.7452 6.18946C19.6194 5.97734 19.4389 5.80295 19.2225 5.68457ZM11 2.7498L17.9051 6.53105L15.3459 7.93097L8.44078 4.14972L11 2.7498ZM11 10.3123L4.09492 6.53105L7.00906 4.93519L13.9141 8.71644L11 10.3123ZM18.5625 15.1119L11.6875 18.8751V11.5008L14.4375 9.99605V13.0623C14.4375 13.2446 14.5099 13.4195 14.6389 13.5484C14.7678 13.6774 14.9427 13.7498 15.125 13.7498C15.3073 13.7498 15.4822 13.6774 15.6111 13.5484C15.7401 13.4195 15.8125 13.2446 15.8125 13.0623V9.24324L18.5625 7.73847V15.1085V15.1119Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyOrder);
export default __webpack_public_path__ + "static/media/easy_order.e746922198ec02b29901c467a2105d0b.svg";
export { ForwardRef as ReactComponent };